export function ContentOverview({ content }) {
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-6">
      <h3 className="text-lg font-semibold mb-4">Content Overview</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center p-4 bg-purple-500/10 rounded-lg border border-purple-500/20">
          <p className="text-3xl font-bold text-purple-400">{content.tracks}</p>
          <p className="text-sm text-gray-400">Tracks</p>
        </div>
        <div className="text-center p-4 bg-cyan-500/10 rounded-lg border border-cyan-500/20">
          <p className="text-3xl font-bold text-cyan-400">{content.albums}</p>
          <p className="text-sm text-gray-400">Albums</p>
        </div>
        <div className="text-center p-4 bg-pink-500/10 rounded-lg border border-pink-500/20">
          <p className="text-3xl font-bold text-pink-400">{content.videos}</p>
          <p className="text-sm text-gray-400">Videos</p>
        </div>
        <div className="text-center p-4 bg-orange-500/10 rounded-lg border border-orange-500/20">
          <p className="text-3xl font-bold text-orange-400">{content.merch_items}</p>
          <p className="text-sm text-gray-400">Merch Items</p>
        </div>
      </div>
    </div>
  );
}
